/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { TFunction } from 'i18next';
import React, { ComponentProps, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../i18n';
import { SimpleNotifyModal } from '../SimpleNotifyModal/SimpleNotifyModal';

type SimpleErrorModalProps = Omit<ComponentProps<typeof SimpleNotifyModal>, 'message'> & {
  message?: string | string[];
  t?: TFunction;
};

export function SimpleErrorModal(props: SimpleErrorModalProps) {
  const i18n = useTranslation([Namespaces.Common]);
  const { message, t = i18n.t, ...notifyModalProps } = props;

  const messages = useMemo<string[]>(() => {
    const m = Array.isArray(message) ? message : [message ?? ''];
    return m.filter(v => v).concat([`${Namespaces.Common}:errors.unexpected_error`]);
  }, [message]);

  return <SimpleNotifyModal {...notifyModalProps} message={t(messages).toString()} />;
}
